import { render, staticRenderFns } from "./ImportWhatsappPhoto.vue?vue&type=template&id=e5706890"
import script from "./ImportWhatsappPhoto.vue?vue&type=script&lang=js"
export * from "./ImportWhatsappPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports